import { Link, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { AI_LEAGUE_INTRO_LINES, AI_LEAGUE_INTRO_TITLE } from '@/constants/aiLeague/aiLeagueContent';
import { pageBodyTextProps, pageSectionTitleProps } from '@/theme/sitePageTypography';

export function AiLeagueIntro(props: { onMethodologyClick: () => void }) {
  const linkColor = useColorModeValue('#2d1eaa', '#a9a0e8');

  return (
    <VStack align='stretch' spacing={4} w='full'>
      <Text {...pageSectionTitleProps}>{AI_LEAGUE_INTRO_TITLE}</Text>
      {AI_LEAGUE_INTRO_LINES.map((line, index) => (
        <Text key={index} {...pageBodyTextProps} textAlign='left'>
          {line}
        </Text>
      ))}
      <Text {...pageBodyTextProps} textAlign='left'>
        If you are interested in the details of what we did and why, you can read the full{' '}
        <Link
          color={linkColor}
          fontWeight='medium'
          textDecoration='underline'
          _hover={{ opacity: 0.85 }}
          onClick={props.onMethodologyClick}
        >
          Methodology
        </Link>{' '}
        here
      </Text>
    </VStack>
  );
}
